import { env } from '@/env';
import { rigaDiagnosi, type AnelloTicket } from '@/lib/chess/diagnosi';

/**
 * LA RIGA DI DIAGNOSI sotto l'errore di CONNESSIONE del tavolo degli scacchi (I-545 / I-555): `<CODICE> · <anello>`, piccola e
 * muta, sotto la frase della banda. Le regole (cosa entra, la lista chiusa dei messaggi, `?` per il resto) stanno in
 * `lib/chess/diagnosi.ts`; qui c'e' solo il flag e il disegno.
 *
 * 🔴 SENZA IL FLAG NON ESISTE NEL DOM, NE' NEL BUNDLE DI PRODUZIONE. Le DUE letture servono entrambe, come per `/burraco`:
 * il confronto LETTERALE `import.meta.env.VITE_FEATURE_DIAGNOSI_TAVOLO_ENABLED === 'true'` e' quello che il bundler piega
 * (in produzione il corpo diventa `return null` e il marcatore `data-diagnosi-tavolo` sparisce dai file); `env.featureDiagnosiTavoloEnabled`
 * e' quello che i test accendono col mock di `@/env`. Acceso SOLO in `.env.staging` (`tools/verify-diagnosi-tavolo.ts`).
 * ⛔ Non si traduce e non si abbellisce: e' per chi collauda, e dice cio' che la frase del giocatore non puo' dire.
 * ⛔ Il ticket, l'indirizzo del socket, i nomi, gli id non arrivano mai qui: `message` esce dalla lista chiusa o come `?`.
 */
export function RigaDiagnosi({ code, message, anello }: { code: string; message: unknown; anello?: AnelloTicket | null }) {
  if (!(import.meta.env.VITE_FEATURE_DIAGNOSI_TAVOLO_ENABLED === 'true' && env.featureDiagnosiTavoloEnabled)) return null;
  return (
    <p
      data-testid="chess-diagnosi"
      data-diagnosi-tavolo=""
      className="px-3 text-center font-mono text-[11px] leading-snug text-fg-muted"
    >
      {rigaDiagnosi({ code, message, anello })}
    </p>
  );
}
